// extracted by mini-css-extract-plugin
export var copyIcon = "_yu-2";
export var discountCard = "_yu-0";
export var discountCode = "_yu-3";
export var discountContent = "_yu-1";
export var loadingCard = "_yu-4";